module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "music-player"
  }, [(_vm.currentMusic) ? _c('audio', {
    ref: "audio",
    attrs: {
      "src": _vm.currentMusic.url,
      "autoplay": ""
    },
    on: {
      "playing": function($event) {
        _vm.paused = false
      },
      "pause": function($event) {
        _vm.paused = true
      },
      "timeupdate": _vm.updateTime,
      "ended": _vm.playNext
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cover"
  }, [(_vm.currentMusicItem) ? _c('img', {
    attrs: {
      "src": _vm.currentMusicItem.al.picUrl
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "actions-before"
  }, [_c('v-btn', {
    staticClass: "teal lighten-2",
    attrs: {
      "fab": "",
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.playPrev
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("skip_previous")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "teal lighten-2",
    attrs: {
      "fab": "",
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.togglePlay
    }
  }, [(!_vm.paused) ? _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("pause")]) : _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("play_arrow")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "teal lighten-2",
    attrs: {
      "fab": "",
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.playNext
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("skip_next")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('p', [(_vm.currentMusicItem) ? _c('span', [_c('span', [_vm._v(_vm._s(_vm.currentMusicItem.name))]), _vm._v("\n        - "), _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.currentMusicItem.ar.map(function (e) { return e.name; }).join(' / ')))])]) : _c('span', [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v("尚未播放歌曲")])]), _vm._v(" "), (_vm.currentMusicItem) ? _c('span', {
    staticClass: "duration"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("parseDuration")(_vm.currentTime)))]), _vm._v("\n        / "), _c('span', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm._f("parseDuration")(_vm.currentMusicItem.dt / 1000)))])]) : _vm._e()]), _vm._v(" "), _c('v-slider', {
    attrs: {
      "dark": "",
      "disabled": !_vm.currentMusic
    },
    on: {
      "input": _vm.setTime
    },
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "actions-after"
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.toggleFavorite(_vm.currentMusicItem)
      }
    }
  }, [(_vm.currentMusicItem && _vm.currentMusicItem.favorited) ? _c('v-icon', {
    staticClass: "red--text"
  }, [_vm._v("favorite")]) : _c('v-icon', [_vm._v("favorite_border")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.switchPlayMode($event)
      }
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.playModeIcon[_vm.playMode]))])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showVolumeControls = !_vm.showVolumeControls
      }
    }
  }, [(_vm.volume > 0) ? _c('v-icon', [_vm._v("volume_up")]) : _c('v-icon', [_vm._v("volume_off")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showPlaylist = !_vm.showPlaylist
      }
    }
  }, [_c('v-icon', [_vm._v("queue_music")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showVolumeControls),
      expression: "showVolumeControls"
    }],
    staticClass: "volume-controls",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-slider', {
    attrs: {
      "dark": "",
      "prepend-icon": _vm.volume > 0 ? 'volume_up' : 'volume_off'
    },
    model: {
      value: (_vm.volume),
      callback: function($$v) {
        _vm.volume = $$v
      },
      expression: "volume"
    }
  })], 1), _vm._v(" "), _c('music-playlist', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPlaylist),
      expression: "showPlaylist"
    }]
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59cf07b9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MusicPlayer.vue
// module id = 150
// module chunks = 1